import { FC } from 'react';
import cn from 'classnames';
import { ContainerProps } from './Container.props';

export const Container: FC<ContainerProps> = ({ className, children }) => {
  return <div className={cn('container relative', className)}>{children}</div>;
};
